import commonConfig from './index.common';

const whiteLabel = process.env.REACT_APP_WHITE_LABEL || 'css';

const specificConfig = require(`./index.${whiteLabel}`).default;

const config = {
    ...commonConfig,
    ...specificConfig
};

export default config;
